import keyMirror from 'keymirror'

export const DOCS_SORT_RULES = keyMirror({
  TENANT_PROJECT_DOCS: null,
})
